<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { FieldA11y } from './form';

  /** Label + control + hint/error, wired for screen readers. */
  let {
    label,
    error,
    hint,
    aside,
    children,
  }: {
    label: string;
    error?: string | undefined;
    hint?: string | undefined;
    /** A small control at the end of the label row, e.g. the «ندارد» tick of a required field. */
    aside?: Snippet;
    children: Snippet<[FieldA11y]>;
  } = $props();

  const id = $props.id();
  const describedBy = $derived(error ? `${id}-error` : hint ? `${id}-hint` : undefined);
  const a11y = $derived<FieldA11y>({
    id,
    'aria-invalid': Boolean(error),
    ...(describedBy ? { 'aria-describedby': describedBy } : {}),
  });
</script>

{#snippet labelEl()}
  <label id={`${id}-label`} for={id} class="text-sm font-medium text-text-2">{label}</label>
{/snippet}

<div class="flex flex-col gap-1.5">
  {#if aside}
    <div class="flex items-center justify-between gap-2">
      {@render labelEl()}
      {@render aside()}
    </div>
  {:else}
    {@render labelEl()}
  {/if}
  {@render children(a11y)}
  {#if error}
    <p id={`${id}-error`} role="alert" class="text-sm text-danger">{error}</p>
  {:else if hint}
    <p id={`${id}-hint`} class="text-sm text-text-3">{hint}</p>
  {/if}
</div>
